










import { Component, Vue } from 'vue-property-decorator'
import { fetchUser } from '@/api'
import { UserResponse } from '@/api/types'
import Cookies from 'js-cookie'

@Component({})
export default class Home extends Vue {
  user: UserResponse | null = null

  async mounted () {
    const userId = Cookies.get('userId')
    this.user = await fetchUser(userId || '')
  }
}
